import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "books", label: "Books" },
  { id: "characters", label: "Characters" },
  { id: "pixie-quiz", label: "Pixie Name" },
  { id: "author", label: "Author" },
  { id: "buy", label: "Shop" },
  { id: "contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#08140B]/80 border-b border-amber-500/15 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          className="flex items-center gap-2 group"
          data-testid="nav-logo"
        >
          <span className="font-accent text-2xl text-gradient-gold tracking-wide">
            Miara Mountain
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="px-4 py-2 text-sm font-medium text-emerald-50/85 hover:text-amber-300 transition-colors relative group"
            >
              {l.label}
              <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-amber-400 scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
            </button>
          ))}
          <button
            onClick={() => scrollTo("buy")}
            className="btn-gold ml-3 text-sm py-2.5 px-5"
            data-testid="nav-cta-buy"
          >
            Buy the Books
          </button>
        </nav>

        <button
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-amber-200 p-2"
          data-testid="nav-toggle-mobile"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden mt-3 mx-4 rounded-2xl glass-card p-4 flex flex-col gap-1"
          data-testid="mobile-menu"
        >
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`mobile-nav-link-${l.id}`}
              className="text-left px-3 py-2 text-emerald-50/90 hover:text-amber-300"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("buy")}
            className="btn-gold mt-2 justify-center"
            data-testid="mobile-nav-cta-buy"
          >
            Buy the Books
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
